import misc from './misc';

const { getEmailQuery, buildTestEmail } = misc;

export default {
  newJobApplicationEmployee: {
    title: 'Internal Mobility » New Job Application Employee',
    description: 'Confirmations email sent to employee after submitting a job application',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.imNewJobApplicationEmployeeEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_IM_NEW_JOB_APPLICATION_EMPLOYEE_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_NEW_JOB_APPLICATION_EMPLOYEE_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_NEW_JOB_APPLICATION_EMPLOYEE_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('internal-mobility/new-job-application-employee', {
      template_subject: 'template.EMAIL_IM_NEW_JOB_APPLICATION_EMPLOYEE_SUBJECT',
      template_bodyOne: 'template.EMAIL_IM_NEW_JOB_APPLICATION_EMPLOYEE_BODY_ONE',
      template_plainHTML: 'template.EMAIL_IM_NEW_JOB_APPLICATION_EMPLOYEE_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        emailHideBrandLogo
        canSyncContacts
        imNewJobApplicationEmployeeEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_NEW_JOB_APPLICATION_EMPLOYEE_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_IM_NEW_JOB_APPLICATION_EMPLOYEE_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_NEW_JOB_APPLICATION_EMPLOYEE_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        user: {
          firstName: 'Miley',
          fullName: 'Miley McMiland',
          application: {
            job: {
              id: 'testid',
              title: 'Full-Time Software Engineer',
            },
            message: 'I think I would be a great candidate because ...',
          },
        },
      };
      return {
        ...result,
        user: {
          ...result.user,
          ...fakeData.user,
        },
      };
    },
  },
  newJobApplicationRecruiter: {
    title: 'Internal Mobility » New Job Application Recruiter',
    description: 'Email sent to recruiter after an employee submitted a job application',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.imNewJobApplicationEmployeeEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_IM_NEW_JOB_APPLICATION_RECRUITER_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_NEW_JOB_APPLICATION_RECRUITER_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_NEW_JOB_APPLICATION_RECRUITER_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('internal-mobility/new-job-application-recruiter', {
      template_subject: 'template.EMAIL_IM_NEW_JOB_APPLICATION_RECRUITER_SUBJECT',
      template_bodyOne: 'template.EMAIL_IM_NEW_JOB_APPLICATION_RECRUITER_BODY_ONE',
      template_plainHTML: 'template.EMAIL_IM_NEW_JOB_APPLICATION_RECRUITER_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        emailHideBrandLogo
        canSyncContacts
        imNewJobApplicationEmployeeEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_NEW_JOB_APPLICATION_RECRUITER_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_IM_NEW_JOB_APPLICATION_RECRUITER_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_NEW_JOB_APPLICATION_RECRUITER_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        company: {
          application: {
            job: {
              id: 'testid',
              title: 'Full-Time Software Engineer',
            },
            message: 'I think I would be a great candidate because ...',
            user: {
              fullName: 'John Doe',
              emailAddress: 'john.doe@email.com',
            },
          },
        },
        user: {
          firstName: 'Miley',
          fullName: 'Miley McMiland',
        },
      };
      return {
        ...result,
        company: {
          ...result.company,
          ...fakeData.company,
        },
        user: {
          ...result.user,
          ...fakeData.user,
        },
      };
    },
  },
  /*
  jobApplicationRejected: {
    title: 'Internal Mobility » Job Application Rejected',
    description: 'Email sent to employee if their application is rejected',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.imJobApplicationRejectedEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_IM_JOB_APPLICATION_REJECTED_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_JOB_APPLICATION_REJECTED_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_JOB_APPLICATION_REJECTED_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('internal-mobility/job-application-rejected', {
      template_subject: 'template.EMAIL_IM_JOB_APPLICATION_REJECTED_SUBJECT',
      template_bodyOne: 'template.EMAIL_IM_JOB_APPLICATION_REJECTED_BODY_ONE',
      template_plainHTML: 'template.EMAIL_IM_JOB_APPLICATION_REJECTED_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        emailHideBrandLogo
        canSyncContacts
        imJobApplicationRejectedEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_JOB_APPLICATION_REJECTED_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_IM_JOB_APPLICATION_REJECTED_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_JOB_APPLICATION_REJECTED_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        user: {
          firstName: 'Miley',
          fullName: 'Miley McMiland',
          application: {
            job: {
              id: 'testid',
              title: 'Full-Stack Software Engineer',
            }
          }
        },
      };
      return {
        ...result,
        user: {
          ...result.user,
          ...fakeData.user,
        },
      };
    },
  }
  */
};



// WEBPACK FOOTER //
// ./src/emails/previews/jobApplicationEmails.js